<template>
  <section class="ON_contact_us_area ON_120px_padding">
    <div class="container">
      <div class="ON_main_article_details">
        <img
          class="img-fluid"
          src="https://www.griffith.ie/sites/default/files/styles/1366x450sc/public/xma-journalism-pr.jpg,qitok=-yIJz7I6.pagespeed.ic.Wd1CnYUd9S.jpg"
          alt=""
        />
      </div>
      <hr />
      <div class="row">
        <div class="col-lg-3">
          <div class="ON_contact_information">
            <div class="ON_contact_information_item">
              <i class="lnr lnr-envelope"></i>
              <h6><a href="#">info@objective-news.com</a></h6>
              <p>Send us your query anytime!</p>
              <link
                href="https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext"
                rel="stylesheet"
              /><a
                class="bmc-button"
                target="_blank"
                href="https://www.buymeacoffee.com/objectiveNews"
                ><img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt="Buy us a coffee"
                /><span style="margin-left:5px;font-size:19px !important;"
                  >Buy us a coffee</span
                ></a
              >
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <form @submit.prevent="formPost" class="row ON_contact_form">
            <div class="col-md-6">
              <div class="form-group">
                <input
                  required="required"
                  type="text"
                  class="form-control"
                  placeholder="Enter your name"
                  v-model="feedbackItem.name"
                />
              </div>
              <div class="form-group">
                <input
                  required="required"
                  type="email"
                  class="form-control"
                  placeholder="Enter email address"
                  v-model="feedbackItem.email"
                />
              </div>
              <div class="form-group">
                <input
                  required="required"
                  type="text"
                  class="form-control"
                  placeholder="Enter Subject"
                  v-model="feedbackItem.subject"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <textarea
                  required="required"
                  class="form-control"
                  rows="1"
                  placeholder="Enter Message"
                  v-model="feedbackItem.message"
                ></textarea>
              </div>
            </div>
            <div
              class="col-md-12 text-right"
              v-if="
                feedbackItem.email !== '' &&
                  feedbackItem.name !== '' &&
                  feedbackItem.subject !== '' &&
                  feedbackItem.message !== ''
              "
            >
              <button class="btn ON_submit_button" @click="formPost">
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import db from "@/fb";

export default {
  data() {
    return {
      feedbackItem: {
        email: "",
        name: "",
        subject: "",
        message: "",
        source: "contactus"
      }
    };
  },
  methods: {
    formPost() {
      db.collection("feedback")
        .add(this.feedbackItem)
        .then(() => {
          (this.feedbackItem.email = ""),
            (this.feedbackItem.name = ""),
            (this.feedbackItem.subject = ""),
            (this.feedbackItem.message = "");
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    }
  },
  created() {
    document.title = "ON Contact Us";
  }
};
</script>
